import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { BottomNav } from '../components/BottomNav';
import { SparklesIcon, ArrowLeftIcon, BellIcon } from 'lucide-react';
export function GrowthTracking() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const currentUser = {
    id: 'user-123',
    name: '妈妈，张春燕',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    points: 720,
    completedLessons: 23,
    streak: 15
  };
  const handleBackClick = () => {
    navigate(-1);
  };
  const toys = [{
    id: 1,
    name: '柔软摇铃',
    image: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ageRange: '0-6个月',
    color: 'from-pink-400 to-rose-400'
  }, {
    id: 2,
    name: '毛绒玩具',
    image: 'https://images.unsplash.com/photo-1530325553241-4f6e7690cf36?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ageRange: '0-3岁',
    color: 'from-purple-400 to-pink-400'
  }, {
    id: 3,
    name: '彩色积木',
    image: 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ageRange: '1-3岁',
    color: 'from-red-400 to-orange-400'
  }, {
    id: 4,
    name: '音乐玩具',
    image: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ageRange: '6个月-2岁',
    color: 'from-blue-400 to-cyan-400'
  }, {
    id: 5,
    name: '布质绘本',
    image: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ageRange: '6个月-3岁',
    color: 'from-green-400 to-emerald-400'
  }, {
    id: 6,
    name: '形状配对',
    image: 'https://images.unsplash.com/photo-1606762216207-056ce4b43baa?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ageRange: '1-3岁',
    color: 'from-indigo-400 to-purple-400'
  }];
  return <div className="flex flex-col min-h-screen bg-gradient-to-b from-purple-50 via-pink-50 to-blue-50 pb-16" data-id="element-192">
      <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-193">
        <div className="px-4 py-3 flex items-center justify-center relative" data-id="element-194">
          <button onClick={handleBackClick} className={'absolute left-4 transition-colors'} data-id="element-195">
            <ArrowLeftIcon size={20} className="mb-1" data-id="element-196" />
            <span className="text-xs font-medium" data-id="element-197">返回</span>
          </button>
          <h1 className="text-2xl font-bold text-amber-700" data-id="element-198">Everseed</h1>
          <div className="flex items-center space-x-3 absolute right-4" data-id="element-199">
            <Link to="/notifications" className="relative" data-id="element-200">
              <BellIcon size={24} className="text-gray-600" data-id="element-201" />
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full font-bold" data-id="element-202">
                3
              </span>
            </Link>
            <img src={currentUser.avatar} alt={currentUser.name} className="w-9 h-9 rounded-full object-cover border-2 border-indigo-200" data-id="element-203" />
          </div>
        </div>
      </header>
      <main className="flex-1 px-4 py-6" data-id="element-204">
        <div className="mb-6" data-id="element-205">
          <div className="flex items-center justify-center mb-4" data-id="element-206">
            <SparklesIcon size={28} className="text-indigo-600 mr-2" data-id="element-207" />
            <h1 className="text-2xl font-bold text-gray-800" data-id="element-208">儿童玩具世界</h1>
            <SparklesIcon size={28} className="text-indigo-600 ml-2" data-id="element-209" />
          </div>
          <p className="text-center text-gray-600 text-sm" data-id="element-210">
            探索适合不同年龄段的益智玩具
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4" data-id="element-211">
          {toys.map(toy => <Link key={toy.id} to={`/toy/${toy.id}`} className="bg-white rounded-2xl overflow-hidden shadow-lg active:scale-95 transition-transform" data-id="element-212">
              <div className="relative aspect-square overflow-hidden" data-id="element-213">
                <img src={toy.image} alt={toy.name} className="w-full h-full object-cover" data-id="element-214" />
                <div className={`absolute bottom-0 left-0 right-0 bg-gradient-to-t ${toy.color} p-3`} data-id="element-215">
                  <h3 className="text-white font-bold text-base mb-1" data-id="element-216">
                    {toy.name}
                  </h3>
                  <div className="flex items-center" data-id="element-217">
                    <span className="text-white text-xs bg-white bg-opacity-30 px-2 py-1 rounded-full" data-id="element-218">
                      {toy.ageRange}
                    </span>
                  </div>
                </div>
              </div>
            </Link>)}
        </div>
        <div className="mt-6 bg-white rounded-2xl p-4 shadow-md" data-id="element-219">
          <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-220">
            为什么玩具很重要?
          </h3>
          <ul className="space-y-2 text-sm text-gray-600" data-id="element-221">
            <li className="flex items-start" data-id="element-222">
              <span className="text-indigo-600 mr-2" data-id="element-223">•</span>
              <span data-id="element-224">促进认知和运动技能发展</span>
            </li>
            <li className="flex items-start" data-id="element-225">
              <span className="text-indigo-600 mr-2" data-id="element-226">•</span>
              <span data-id="element-227">培养创造力和想象力</span>
            </li>
            <li className="flex items-start" data-id="element-228">
              <span className="text-indigo-600 mr-2" data-id="element-229">•</span>
              <span data-id="element-230">增强社交和情感能力</span>
            </li>
            <li className="flex items-start" data-id="element-231">
              <span className="text-indigo-600 mr-2" data-id="element-232">•</span>
              <span data-id="element-233">提供安全的学习环境</span>
            </li>
          </ul>
        </div>
      </main>
      <BottomNav data-id="element-234" />
    </div>;
}